import { defineStore } from 'pinia';
import { ref } from 'vue';

import { useFerryFiltersStore } from '@apps/main/new-desktop/core/stores/filters/ferryFiltersStore';

import type { IngredientId } from '@libs/trip-planner-interfaces';

export enum FerryListPanelType {
  None = 'None',
  Filters = 'Filters',
}

export const useFerryListPanelsStore = defineStore(
  'FerryListPanelsStore',
  () => {
    const ferryFiltersStore = useFerryFiltersStore();

    // State
    const panelType = ref<FerryListPanelType>(FerryListPanelType.None);

    // Actions
    function closePanel(): void {
      panelType.value = FerryListPanelType.None;
    }

    function openFiltersPanel(ingredientId?: IngredientId): void {
      if (ingredientId) {
        ferryFiltersStore.setAllowedFerryIngredientIds([ingredientId]);
      }
      panelType.value = FerryListPanelType.Filters;
    }

    function closeFitersPanel(): void {
      ferryFiltersStore.clearAllowedFerryIngredientIds();
      closePanel();
    }

    return {
      // State
      panelType,

      // State
      closePanel,
      openFiltersPanel,
      closeFitersPanel,
    };
  }
);
